import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import '@/styles/index.css'
import { tanstackQueryClient, tanstackRouter } from '@/tanstackSetup'

const App = () => {
  return (
    <QueryClientProvider client={tanstackQueryClient}>
      <RouterProvider router={tanstackRouter} />
    </QueryClientProvider>
  )
}

export default App
